import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "./swiper.css";

// Client Logos
import img1 from "../../../assets/images/Industry Page/swiper/Education.png";
import img2 from "../../../assets/images/Industry Page/swiper/Logistics.png";
import img3 from "../../../assets/images/Industry Page/swiper/event.png";
import img4 from "../../../assets/images/Industry Page/swiper/finance.png";
import img5 from "../../../assets/images/Industry Page/swiper/oil-gas.png";
import img6 from "../../../assets/images/Industry Page/swiper/productivity.png";
import img7 from "../../../assets/images/Industry Page/swiper/retail.png";
import img8 from "../../../assets/images/Industry Page/swiper/social-network.png";
import img9 from "../../../assets/images/Industry Page/swiper/transportation.png";
import img10 from "../../../assets/images/Industry Page/swiper/travel.png";
import img11 from "../../../assets/images/Industry Page/swiper/wellness-fitness.png";


const Client = () => {
    const [isGray, setIsGray] = useState(true);

    // After 1 hour, switch logos to original color
    useEffect(() => {
        const timer = setTimeout(() => {
            setIsGray(false);
        }, 60 * 60 * 1000); // 1 hour
        return () => clearTimeout(timer);
    }, []);

    // Array of imported logos
    const logos = [
        { img: img1, name: "Education" },
        { img: img2, name: "Logistics" },
        { img: img3, name: "Event" },
        { img: img4, name: "Finance" },
        { img: img5, name: "Oil & Gas" },
        { img: img6, name: "Productivity" },
        { img: img7, name: "Retail" },
        { img: img8, name: "Social Network" },
        { img: img9, name: "Transportation" },
        { img: img10, name: "Travel" },
        { img: img11, name: "Wellness & Fitness" },
    ];


    return (
        <section className="slider-section">
            <h2 className="client-title">Industries We Serve</h2>

            <div className="client-container">
                <Swiper
                    modules={[Autoplay]}
                    spaceBetween={20}
                    loop={true}
                    speed={800}
                    autoplay={{
                        delay: 1500,
                        disableOnInteraction: false,
                    }}

                    breakpoints={{
                        // Mobile (0px - 640px)
                        0: {
                            slidesPerView: 2,
                            spaceBetween: 10,
                        },
                        // Tablets (640px - 1024px)
                        640: {
                            slidesPerView: 3,
                        },
                        // Desktop (1024px+)
                        1024: {
                            slidesPerView: 6,
                        },
                    }}
                >
                    {logos.map((item, index) => (
                        <SwiperSlide key={index}>
                            <div className="slider-logo-box" style={{ "--bg": `url(${item.img})` }}>
                                <img src={item.img} alt={`Client ${index + 1}`} />
                                {/* Name under image */}
                                <p className="logo-caption">{item.name}</p>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </section>
    );
};

export default Client;
